import React from 'react';
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
  return {
    filters: state.entry.filters.map( function(object){
      return object.field
    })
  }
}

class ConnectedHeaderRenderer extends React.Component {
  render() {
    const {name, field, filters} = this.props

    const isFiltered = (filters.indexOf(field) > -1) ? (
      <div className="filteredColumn">filtered</div>
    ) : ''
    return (
      <div>
        <div className="headerTitle">{ name }</div>
        { isFiltered }
      </div>
    )
  }
}

const HeaderRenderer = connect(mapStateToProps)(ConnectedHeaderRenderer)

export default HeaderRenderer



// WEBPACK FOOTER //
// ./src/js/components/HeaderRenderer.js